import styled from "@emotion/styled";
import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";

export const ProductImageCell = styled(ResponsiveTableCell)`
  width: 70px;
  padding: 1rem 0;
  img {
    margin: 0 auto;
    display: block;
  }
  img::before {
    content: " ";
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    background-image: url("http://cdn.onlinewebfonts.com/svg/img_148071.png");
  }
`;
